import React from "react";
import ReactDOM from "react-dom";
import eventBus from "../../../../../util/eventBus";
import "./index.less";
import { Icon, Tooltip } from "@kdcloudjs/kdesign";
import "@kdcloudjs/kdesign/dist/kdesign.css";
import Grid from "./components/Grid/Grid";
import KdTooltip from "./components/KdTooltip/KdTooltip";
/**
 * 在setHtml中声明Root类，使用ReactDOM.render将其渲染在model.dom中
 * 在Root类的componentDidMount里，声明一个订阅，用于接收后端更新发过来的消息，从而去更新组件
 * 在update里，发布一个消息，当后端插件给自定义控件传递新数据时，就能将消息发布给Root
 * 在Root类的componentWillUnmount里，取消订阅
 * 在destoryed里，使用ReactDOM.unmountComponentAtNode卸载Root
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
(function (KDApi) {
  function talentAxis(model) {
    this._setModel(model);
  }

  talentAxis.prototype = {
    _setModel: function (model) {
      this.model = model;
      this.I18N = (key) => KDApi.getLangMsg(model, key);
    },
    init: function (props) {
      console.log("-----init", this.model.style, props);
      setHtml(this.model, props);
    },
    update: function (props) {
      console.log("-----update", this.model, props);
      eventBus.pub(this.model, "update", props);
    },
    destoryed: function () {
      console.log("-----destoryed", this.model);
      ReactDOM.unmountComponentAtNode(this.model.dom);
    },
  };

  var gradeArray = [
    "Lv 1 未胜任务",
    "Lv 3 绩效不佳",
    "Lv 6 待观察者",
    "Lv 2 表现尚可",
    "Lv 5 中坚力量",
    "Lv 8 明日之星",
    "Lv 4 稳定贡献",
    "Lv 7 表现出色",
    "Lv 9 超级明星",
  ];
  const colorArray = [
    "linear-gradient(72deg,#eef0f5,#f5f5f5)",
    "linear-gradient(72deg,#e9ecf4,#f5f5f5)",
    "linear-gradient(72deg,#e9ecf4,#f5f5f5)",
    "linear-gradient(72deg,#eef0f5,#f5f5f5)",
    "linear-gradient(72deg,#e9ecf4,#f5f5f5)",
    "linear-gradient(72deg,#e9ecf4,#f5f5f5)",
    "linear-gradient(72deg,#eef0f5,#f5f5f5)",
    "linear-gradient(73deg,#eff7ff,#d5e8ff)",
    "linear-gradient(73deg,#eff7ff,#d5e8ff)",
  ];

  var xAxisScales = 3,
    yAxisScales = 3;
  var data = {
    lockIconVisible: true,
    gridTplLock: true,
    xAxisInfo: {
      name: "能力",
      valueType: {
        type: "grade",
        lock: false,
      },
      divideScale: {
        values: ["较差", "中等", "优秀"],
        lock: true,
        range: "left",
      },
    },
    yAxisInfo: {
      name: "绩效",
      valueType: {
        type: "grade",
        lock: false,
      },
      divideScale: {
        values: ["低", "中", "高"],
        lock: false,
        range: "false",
      },
    },
    distributionRatio: {
      values: Array.from({ length: xAxisScales * yAxisScales }, (_, index) => ({
        gridBlockNo: index,
        ratio: "",
      })),
      lock: false,
    },
    gridData: {
      colorScheme: "#156476",
      xAxisScales: xAxisScales,
      yAxisScales: yAxisScales,
      gridBlocks: Array.from(
        { length: xAxisScales * yAxisScales },
        (_, index) => ({
          number: index + 1,
          name: {
            text: gradeArray[index],
            fontColor: "#666",
          },
          backColor: colorArray[index],
        })
      ),
    },
    personInfo: {
      personNmme: "xxx",
      headSculpture:
        "https://feature.kingdee.com:1026/feature_sit_hr/attachment/downloadImage/tenant_feature_sit_hr_test/1442606446318454784/202305/base/bos_user/images/avatar/yujie118-AvC5lVaq.png",
      number: "8",
    },
  };

  var setHtml = function (model, primaryProps) {
    KDApi.loadFile("./css/index.css", model, () => {
      class Root extends React.Component {
        constructor(props) {
          super(props);
          this.state = {
            customProps: props.customProps,
            model: props.model,
            data: props.customProps?.data?.data || data,
          };
        }
        componentDidMount() {
          console.log(this.props);
          const { model } = this.state;
        }
        componentWillUnmount() {}

        render() {
          const {
            distributionRatio,
            gridData,
            xAxisInfo,
            yAxisInfo,
            personInfo,
          } = this.state.data || {};
          const isViewEditStatus = false;

          const isActivity = this.state.customProps?.data?.pageSource === false;
          return (
            <div
              className={[
                "talent-axis-container",
                isViewEditStatus ? "talent-axis-container-view-status" : "",
              ].join(" ")}
            >
              {this.state.data ? (
                <>
                  <div className="main-right-wrapper">
                    <div className="main-right">
                      <Icon
                        className="up-icon-wrapper"
                        type="arrow-up-solid"
                        style={{ fontSize: "20px" }}
                      ></Icon>
                      <Icon
                        className="right-icon-wrapper"
                        type="arrow-right-solid"
                        style={{ fontSize: "20px" }}
                      ></Icon>
                      <KdTooltip
                        className={"y-title"}
                        tip={yAxisInfo.name}
                        innerstyle={{ marginLeft: "auto" }}
                        content={yAxisInfo.name}
                      />
                      <KdTooltip
                        className={"x-title"}
                        tip={xAxisInfo.name}
                        content={xAxisInfo.name}
                      />
                      <Grid
                        gridData={gridData}
                        values={[]}
                        personInfo={personInfo}
                      />
                      {["percent", "score"].includes(
                        xAxisInfo.valueType.type
                      ) ||
                      ["percent", "score"].includes(
                        yAxisInfo.valueType.type
                      ) ? (
                        <div className="x-y-zero">
                          0<Icon type={"arrow-up-solid"}></Icon>
                        </div>
                      ) : null}
                      <div className="yAxis-wrapper">
                        <div
                          className={"yAxis-list"}
                          style={{
                            gridTemplateRows: `repeat(${yAxisInfo.divideScale.values.length}, 1fr)`,
                          }}
                        >
                          {yAxisInfo.divideScale.values
                            .reduce((acc, num) => [num, ...acc], [])
                            .map((item, index) => (
                              <div>
                                <div
                                  style={{
                                    bottom:
                                      yAxisInfo.valueType.type === "grade"
                                        ? "50%"
                                        : index !== 0
                                        ? "calc(100% + 10px)"
                                        : "100%",
                                    paddingRight:
                                      yAxisInfo.valueType.type === "grade"
                                        ? "8px"
                                        : "12px",
                                  }}
                                >
                                  {item ? (
                                    <Tooltip placement="topRight" tip={item}>
                                      <div>{item}</div>
                                    </Tooltip>
                                  ) : (
                                    ""
                                  )}
                                  {yAxisInfo.valueType.type == "grade" ||
                                  !item ? null : (
                                    <Icon type={"arrow-right-solid"}></Icon>
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                      <div className="xAxis-wrapper">
                        <div
                          className={"xAxis-list"}
                          style={{
                            gridTemplateColumns: `repeat(${xAxisInfo.divideScale.values.length}, 1fr)`,
                          }}
                        >
                          {xAxisInfo.divideScale.values.map((item, index) => (
                            <div>
                              <div
                                style={{
                                  left:
                                    xAxisInfo.valueType.type === "grade"
                                      ? "50%"
                                      : index !==
                                        xAxisInfo.divideScale.values.length - 1
                                      ? "calc(100% + 10px)"
                                      : "100%",
                                }}
                              >
                                <Tooltip tip={item}>
                                  <div>{item}</div>
                                </Tooltip>
                                {xAxisInfo.valueType.type === "grade" ||
                                !item ? null : (
                                  <Icon type={"arrow-up-solid"}></Icon>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          );
        }
      }
      ReactDOM.render(
        <Root model={model} customProps={primaryProps} />,
        model.dom
      );
    });
  };

  // 注册自定义组件
  KDApi.register("talentAxis", talentAxis);
})(window.KDApi);
